import { useQueryClient } from '@tanstack/react-query';
import { Form } from 'components/organisms';
import { listQueryKeys } from 'constants/queryKey';
import { FormikHelpers } from 'formik';
import { useNavigate } from 'react-router-dom';
import { usePostThread } from 'services/chat';
import { ICreateThread } from 'services/chat/types';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const CreateSupportThreadChat = () => {
  const createThread = usePostThread();

  const queryClient = useQueryClient();

  const navigate = useNavigate();

  const onCreateThread = async (
    values: ICreateThread,
    formikHelpers: FormikHelpers<ICreateThread>,
  ) =>
    await createThread.mutateAsync(values, {
      onSuccess: async (thread) => {
        navigate(`/support/${thread.messageThreadId}`);
        await queryClient.invalidateQueries({
          queryKey: [listQueryKeys.thread],
        });
        formikHelpers.resetForm();
      },
      onError: (error) => onErrorShowAllErrorsToast(error),
    });

  return <Form.Support onSubmit={onCreateThread} isPending={createThread.isPending} />;
};

export default CreateSupportThreadChat;
